const texts = {
    "success-page.go-to-brand": {
        EN: "Go to",
        DA: "Gå til",
        DE: "Gehe zu",
        NL: "Ga naar",
        FR: "Aller à",
        IT: "Vai a",
        ES: "Ir a",
        PT: "Ir para",
        FI: "Siirry",
        SV: "Gå till",
        NO: "Gå til",
    },
    "success-page.make-another-return": {
        EN: "Register another return",
        DA: "Registrer en anden retur",
        DE: "Weitere Rückgabe registrieren",
        NL: "Registreer een andere retour",
        FR: "Enregistrer un autre retour",
        IT: "Registra un altro reso",
        ES: "Registrar otra devolución",
        PT: "Registrar outra devolução",
        FI: "Rekisteröi toinen palautus",
        SV: "Gör en till retur",
        NO: "Registrer en ny retur",
    },
    "confirmation-page.EXCHANGE_ON_RETURN": {
        EN: "Your exchanged items will be shipped after your returned items have been checked at the store",
        DA: "Dine ombyttede varer vil blive sendt efter at dine returnerede varer er blevet tjekket i butikken",
        DE: "Ihre umgetauschten Artikel werden verschickt, nachdem Ihre zurückgegebenen Artikel im Geschäft überprüft wurden",
        NL: "Je geruilede artikelen worden verzonden nadat je geretourneerde artikelen in de winkel zijn gecontroleerd",
        FR: "Vos articles échangés seront expédiés après que vos articles retournés aient été vérifiés en magasin",
        IT: "I tuoi articoli cambiati verranno spediti dopo che i tuoi articoli restituiti sono stati controllati in negozio",
        ES: "Tus artículos cambiados serán enviados después de que tus artículos devueltos hayan sido verificados en la tienda",
        PT: "Seus itens trocados serão enviados após seus itens devolvidos serem verificados na loja",
        FI: "Vaihtotuotteesi lähetetään sen jälkeen kun palautetut tuotteesi on tarkistettu kaupassa",
        SV: "Dina nya varor kommer skickas efter att dina returnerade varor har kontrollerats av butiken",
        NO: "Dine nye varer vil bli sendt etter at dine returnerte varer er sjekket av butikken ",
    },
    "confirmation-page.EXCHANGE_ON_SHIPMENT": {
        EN: "Your exchanged items will be shipped after your returned items have been handed over to your selected carrier",
        DA: "Dine ombyttede varer vil blive sendt efter at dine returnerede varer er blevet overdraget til din valgte fragtmand",
        DE: "Ihre umgetauschten Artikel werden verschickt, nachdem Ihre zurückgegebenen Artikel an Ihren ausgewählten Spediteur übergeben wurden",
        NL: "Je geruilede artikelen worden verzonden nadat je geretourneerde artikelen zijn overhandigd aan je geselecteerde vervoerder",
        FR: "Vos articles échangés seront expédiés après que vos articles retournés aient été remis à votre transporteur sélectionné",
        IT: "I tuoi articoli cambiati verranno spediti dopo che i tuoi articoli restituiti sono stati consegnati al corriere selezionato",
        ES: "Tus artículos cambiados serán enviados después de que tus artículos devueltos hayan sido entregados a tu transportista seleccionado",
        PT: "Seus itens trocados serão enviados após seus itens devolvidos serem entregues à transportadora selecionada",
        FI: "Vaihtotuotteesi lähetetään sen jälkeen kun palautetut tuotteesi on luovutettu valitsemallesi kuljettajalle",
        SV: "Dina nya varor kommer skickas efter att dina returnerade varor har lämnats in på valt ombud",
        NO: "Dine nye varer vil bli sendt etter at dine returnerte varer er levert inn på valgt utleveringssted",
    },
    "confirmation-page.pause-invoice": {
        EN: "Do you want to pause your invoice?",
        DA: "Vil du sætte din faktura på pause?",
        DE: "Möchten Sie Ihre Rechnung pausieren?",
        NL: "Wil je je factuur pauzeren?",
        FR: "Voulez-vous suspendre votre facture?",
        IT: "Vuoi mettere in pausa la tua fattura?",
        ES: "¿Quieres pausar tu factura?",
        PT: "Você quer pausar sua fatura?",
        FI: "Haluatko keskeyttää laskusi?",
        SV: "Vill du pausa din faktura?",
        NO: "Vil du sette fakturaen på pause?",
    },
    "confirmation-page.submit-error": {
        EN: "An error occurred. Please try again later.",
        DA: "Der opstod en fejl. Prøv igen senere.",
        DE: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
        NL: "Er is een fout opgetreden. Probeer het later opnieuw.",
        FR: "Une erreur s'est produite. Veuillez réessayer plus tard.",
        IT: "Si è verificato un errore. Riprova più tardi.",
        ES: "Se produjo un error. Inténtalo de nuevo más tarde.",
        PT: "Ocorreu um erro. Tente novamente mais tarde.",
        FI: "Tapahtui virhe. Yritä myöhemmin uudelleen.",
        SV: "Det uppstod ett fel. Försök igen senare.",
        NO: "Det oppstod en feil. Prøv igjen senere.",
    },
    "confirmation-page.refund.FAST_REFUND": {
        EN: "Fast refund",
        DA: "Hurtig refusion",
        DE: "Schnelle Rückerstattung",
        NL: "Snelle terugbetaling",
        FR: "Remboursement rapide",
        IT: "Rimborso veloce",
        ES: "Reembolso rápido",
        PT: "Reembolso rápido",
        FI: "Nopea hyvitys",
        SV: "Snabb återbetalning",
        NO: "Rask refusjon",
    },
    "confirmation-page.refund.SHIPPING_REFUND": {
        EN: "Shipping refund",
        DA: "Forsendelsesrefusion",
        DE: "Versanderstattung",
        NL: "Verzendterugbetaling",
        FR: "Remboursement de livraison",
        IT: "Rimborso spedizione",
        ES: "Reembolso de envío",
        PT: "Reembolso de envio",
        FI: "Toimituksen hyvitys",
        SV: "Återbetalning av frakt",
        NO: "Refusjon av frakt",
    },
    "confirmation-page.refund.EXCHANGE_COST": {
        EN: "Exchange cost",
        DA: "Omkostning ved ombytning",
        DE: "Umtauschkosten",
        NL: "Ruilkosten",
        FR: "Frais d'échange",
        IT: "Costo di cambio",
        ES: "Costo de cambio",
        PT: "Custo de troca",
        FI: "Vaihdon kustannus",
        SV: "Byteskostnad",
        NO: "Byttekostnad",
    },
    "confirmation-page.refund.RETURN_COST": {
        EN: "Shipping cost",
        DA: "Forsendelsesomkostninger",
        DE: "Versandkosten",
        NL: "Verzendkosten",
        FR: "Frais de livraison",
        IT: "Costi di spedizione",
        ES: "Costo de envío",
        PT: "Custo de envio",
        FI: "Toimitusmaksu",
        SV: "Fraktkostnad",
        NO: "Fraktkostnad",
    },
    "confirmation-page.refund.RETURN_SHIPMENT_COST": {
        EN: "Shipping cost",
        DA: "Forsendelsesomkostninger",
        DE: "Versandkosten",
        NL: "Verzendkosten",
        FR: "Frais de livraison",
        IT: "Costi di spedizione",
        ES: "Costo de envío",
        PT: "Custo de envio",
        FI: "Toimitusmaksu",
        SV: "Returfrakt",
        NO: "Returfrakt",
    },
    "confirmation-page.refund.RETURN_HANDLING_COST": {
        EN: "Return fee",
        DA: "Returgebyr",
        DE: "Rücksendegebühr",
        NL: "Retourkosten",
        FR: "Frais de retour",
        IT: "Tariffa di reso",
        ES: "Tarifa de devolución",
        PT: "Taxa de devolução",
        FI: "Palautusmaksu",
        SV: "Returavgift",
        NO: "Håndteringskostnad",
    },
    "confirmation-page.refund.GIFT_CARD_ADDITION": {
        EN: "Gift card (${bonusPercentage}% extra)",
        DA: "Gavekort (${bonusPercentage}% ekstra)",
        DE: "Geschenkkarte (${bonusPercentage}% extra)",
        NL: "Cadeaukaart (${bonusPercentage}% extra)",
        FR: "Carte cadeau (${bonusPercentage}% en plus)",
        IT: "Carta regalo (${bonusPercentage}% extra)",
        ES: "Tarjeta de regalo (${bonusPercentage}% extra)",
        PT: "Cartão-presente (${bonusPercentage}% extra)",
        FI: "Lahjakortti (${bonusPercentage}% lisää)",
        SV: "Presentkort (${bonusPercentage}% extra)",
        NO: "Gavekort (${bonusPercentage}% extra)",
    },
    "confirmation-page.refund.GIFT_CARD_ADDITION_NO_BONUS": {
        EN: "Gift card",
        DA: "Gavekort",
        DE: "Geschenkkarte",
        NL: "Cadeaukaart",
        FR: "Carte cadeau",
        IT: "Carta regalo",
        ES: "Tarjeta de regalo",
        PT: "Cartão-presente",
        FI: "Lahjakortti",
        SV: "Presentkort",
        NO: "Gavekort",
    },
    "confirmation-page.invalid-refund": {
        EN: "You have to select how you wish to be refunded",
        DA: "Du skal vælge hvordan du ønsker at blive refunderet",
        DE: "Sie müssen auswählen, wie Sie erstattet werden möchten",
        NL: "Je moet selecteren hoe je wilt worden terugbetaald",
        FR: "Vous devez sélectionner comment vous souhaitez être remboursé",
        IT: "Devi selezionare come desideri essere rimborsato",
        ES: "Debes seleccionar cómo deseas ser reembolsado",
        PT: "Você deve selecionar como deseja ser reembolsado",
        FI: "Sinun täytyy valita miten haluat hyvityksen",
        SV: "Du måste välja hur du vill bli återbetald",
        NO: "Du må velge hvordan du ønsker å bli refundert",
    },
    "confirmation-page.invalid-invoice": {
        EN: "You have to select if you want to pause your invoice",
        DA: "Du skal vælge om du vil sætte din faktura på pause",
        DE: "Sie müssen auswählen, ob Sie Ihre Rechnung pausieren möchten",
        NL: "Je moet selecteren of je je factuur wilt pauzeren",
        FR: "Vous devez sélectionner si vous souhaitez suspendre votre facture",
        IT: "Devi selezionare se vuoi mettere in pausa la tua fattura",
        ES: "Debes seleccionar si quieres pausar tu factura",
        PT: "Você deve selecionar se deseja pausar sua fatura",
        FI: "Sinun täytyy valita haluatko keskeyttää laskusi",
        SV: "Du måste välja om du vill pausa din faktura",
        NO: "Du må velge om du vil sette fakturaen på pause",
    },
    "confirmation-page.refund-options.BASIC.header": {
        EN: "Refund",
        DA: "Refusion",
        DE: "Rückerstattung",
        NL: "Terugbetaling",
        FR: "Remboursement",
        IT: "Rimborso",
        ES: "Reembolso",
        PT: "Reembolso",
        FI: "Hyvitys",
        SV: "Återbetalning",
        NO: "Refusjon",
    },
    "confirmation-page.refund-options.BASIC.header-resale": {
        EN: "Basic payout (free)",
        DA: "Grundlæggende udbetaling (gratis)",
        DE: "Grundauszahlung (kostenlos)",
        NL: "Basis uitbetaling (gratis)",
        FR: "Paiement de base (gratuit)",
        IT: "Pagamento base (gratuito)",
        ES: "Pago básico (gratis)",
        PT: "Pagamento básico (grátis)",
        FI: "Perusmaksu (ilmainen)",
        SV: "Vanlig utbetalning (gratis)",
        NO: "Grunnleggende utbetaling (gratis)",
    },
    "confirmation-page.refund-options.BASIC.text": {
        EN: "Refund to original payment method",
        DA: "Refusion til original betalingsmetode",
        DE: "Rückerstattung erfolgt auf deine gewählte Zahlungsart",
        NL: "De terugbetaling wordt gedaan via dezelfde betaalmethode die je hebt gebruikt bij het bestellen",
        FR: "Remboursement sur le mode de paiement d'origine",
        IT: "Rimborso sul metodo di pagamento originale",
        ES: "Reembolso al método de pago original",
        PT: "Reembolso para o método de pagamento original",
        FI: "Hyvitys alkuperäiseen maksuvälineeseen",
        SV: "Återbetalning till samma betalningsmetod",
        NO: "Refusjon til opprinnelig betalingsmåte",
    },
    "confirmation-page.refund-options.FAST.header": {
        EN: "Fast refund, ${price} ${currencyCode}",
        DA: "Hurtig refusion, ${price} ${currencyCode}",
        DE: "Schnelle Rückerstattung, ${price} ${currencyCode}",
        NL: "Snelle terugbetaling, ${price} ${currencyCode}",
        FR: "Remboursement rapide, ${price} ${currencyCode}",
        IT: "Rimborso veloce, ${price} ${currencyCode}",
        ES: "Reembolso rápido, ${price} ${currencyCode}",
        PT: "Reembolso rápido, ${price} ${currencyCode}",
        FI: "Nopea hyvitys, ${price} ${currencyCode}",
        SV: "Snabb återbetalning, ${price} ${currencyCode}",
        NO: "Rask refusjon, ${price} ${currencyCode}",
    },
    "confirmation-page.refund-options.FAST.header-resale": {
        EN: "Fast payout (${price})",
        DA: "Hurtig udbetaling (${price})",
        DE: "Schnelle Auszahlung (${price})",
        NL: "Snelle uitbetaling (${price})",
        FR: "Paiement rapide (${price})",
        IT: "Pagamento veloce (${price})",
        ES: "Pago rápido (${price})",
        PT: "Pagamento rápido (${price})",
        FI: "Nopea maksu (${price})",
        SV: "Snabb utbetalning (${price})",
        NO: "Rask utbetaling (${price})",
    },
    "confirmation-page.refund-options.FAST.text": {
        EN: "On your bank account within 5 min",
        DA: "På din bankkonto inden 5 min",
        DE: "Auf Ihrem Bankkonto innerhalb von 5 Min",
        NL: "Op je bankrekening binnen 5 min",
        FR: "Sur votre compte bancaire sous 5 min",
        IT: "Sul tuo conto bancario entro 5 min",
        ES: "En tu cuenta bancaria en 5 min",
        PT: "Em sua conta bancária em 5 min",
        FI: "Tilillesi 5 minuutissa",
        SV: "På ditt bankkonto inom 5 min",
        NO: "På bankkontoen din innen 5 min",
    },
    "confirmation-page.refund-options.GIFT_CARD.header": {
        EN: "Gift Card Refund b{+${bonusPercentage}% EXTRA}",
        DA: "Gavekort refusion b{+${bonusPercentage}% EKSTRA}",
        DE: "Geschenkkarte Rückerstattung b{+${bonusPercentage}% EXTRA}",
        NL: "Cadeaukaart terugbetaling b{+${bonusPercentage}% EXTRA}",
        FR: "Remboursement carte cadeau b{+${bonusPercentage}% EN PLUS}",
        IT: "Rimborso carta regalo b{+${bonusPercentage}% EXTRA}",
        ES: "Reembolso tarjeta de regalo b{+${bonusPercentage}% EXTRA}",
        PT: "Reembolso cartão-presente b{+${bonusPercentage}% EXTRA}",
        FI: "Lahjakorttihyvitys b{+${bonusPercentage}% LISÄÄ}",
        SV: "Presentkort, få ${bonusPercentage}% extra",
        NO: "Gavekort, få ${bonusPercentage}% extra",
    },
    "confirmation-page.refund-options.GIFT_CARD.header-no-bonus": {
        EN: "Gift Card Refund",
        DA: "Gavekort refusion",
        DE: "Geschenkkarte Rückerstattung",
        NL: "Cadeaukaart terugbetaling",
        FR: "Remboursement carte cadeau",
        IT: "Rimborso carta regalo",
        ES: "Reembolso tarjeta de regalo",
        PT: "Reembolso cartão-presente",
        FI: "Lahjakorttihyvitys",
        SV: "Presentkort",
        NO: "Gavekort",
    },
    "confirmation-page.refund-options.GIFT_CARD.header-resale": {
        EN: "Gift Card, get ${bonusPercentage}% extra",
        DA: "Gavekort, få ${bonusPercentage}% ekstra",
        DE: "Geschenkkarte, erhalte ${bonusPercentage}% extra",
        NL: "Cadeaukaart, krijg ${bonusPercentage}% extra",
        FR: "Carte cadeau, obtenez ${bonusPercentage}% en plus",
        IT: "Carta regalo, ricevi ${bonusPercentage}% extra",
        ES: "Tarjeta de regalo, obtén ${bonusPercentage}% extra",
        PT: "Cartão-presente, ganhe ${bonusPercentage}% extra",
        FI: "Lahjakortti, saat ${bonusPercentage}% lisää",
        SV: "Presentkort, få ${bonusPercentage}% extra",
        NO: "Gavekort, få ${bonusPercentage}% extra",
    },
    "confirmation-page.refund-options.GIFT_CARD.text": {
        EN: "Receive your refund as a voucher to use on your next purchase",
        EN_TR: "Receive your refund as a giftcard to use on your next purchase",
        DA: "Modtag din refusion som en kupon til brug ved dit næste køb",
        DE: "Erhalten Sie Ihre Rückerstattung als Gutschein für Ihren nächsten Einkauf",
        NL: "Ontvang je terugbetaling als een voucher voor je volgende aankoop",
        FR: "Recevez votre remboursement sous forme de bon à utiliser lors de votre prochain achat",
        IT: "Ricevi il tuo rimborso come buono da utilizzare per il tuo prossimo acquisto",
        ES: "Recibe tu reembolso como un vale para usar en tu próxima compra",
        PT: "Receba seu reembolso como um voucher para usar em sua próxima compra",
        FI: "Saat hyvityksesi lahjakorttina käytettäväksi seuraavaan ostokseen",
        SV: "Återbetalning som ett presentkort att använda vid ditt nästa köp",
        NO: "Refusjon som et gavekort til bruk ved neste kjøp",
    },
    "confirmation-page.refund-options.GIFT_CARD.best-value": {
        EN: "Best value",
        DA: "Bedste værdi",
        DE: "Bester Wert",
        NL: "Beste waarde",
        FR: "Meilleure valeur",
        IT: "Miglior valore",
        ES: "Mejor valor",
        PT: "Melhor valor",
        FI: "Paras arvo",
        SV: "Prisvärt",
        NO: "Best verdi",
    },
};
export default texts;
